import { Injectable } from "@angular/core";
import { AppVersion } from "@ionic-native/app-version";
import { TranslateService } from "@ngx-translate/core";
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { APP_CONFIG, COUNTRY_CONFIG } from "../../environment";
import { HttpProvider } from "../http/http";

declare let device;

@Injectable()
export class HttpMapper {
  private version: string = "0.1";

  constructor(
    private appVersion: AppVersion,
    public http: HttpProvider,
    private translate: TranslateService,
    private platform: Platform,
  ) {
    this.platform.ready().then(
      async () => {
        if (this.platform.is('cordova'))
          this.version = await this.appVersion.getVersionNumber();
      },
    );
  }

  public get(path: string): Observable<any> {
    return Observable.fromPromise(this.http.get(path, {}, null, this.createHeaders()));
  }

  public post(path: string, data: any): Observable<any> {
    return Observable.fromPromise(this.http.post(path, data, null, this.createHeaders()));
  }

  public put(path: string, data: any): Observable<any> {
    return Observable.fromPromise(this.http.put(path, data, null, this.createHeaders()));
  }

  public delete(path: string): Observable<any> {
    return Observable.fromPromise((this.http.delete(path, {}, null, this.createHeaders())));
  }

  public deletePush(path: string, data: any): Observable<any> {
    return new Observable();
    //TODO: Review how to use qith native
    //return Observable.fromPromise(this.http.request("delete", path, { body: data }));
  }

  private createHeaders() {
    const currentLang = this.http.getTranslateLang();
    let headers = {
      AppType: '1',
      Brand: APP_CONFIG.branding.httpBrand,
      AppVersion: this.http.getHeaderVersion(),
      Authorization: (HttpProvider.authToken) ? ("Bearer " + HttpProvider.authToken) : "",
      CountryId: APP_CONFIG.region.regionId.toString(),
      Locale: currentLang ? currentLang : COUNTRY_CONFIG.DEFAULT_LANG
    };
    if (typeof device !== "undefined") {
      headers["Platform"] = device.platform;
      headers["PlatformVersion"] = device.version;
    }

    // IMPROVE WORKAROUND: CST is throwing errors for any region code except en-US and en-CA (like en-IT), also handles en-WA
    if (headers.Locale && headers.Locale.substr(0, 3) === 'en-' && headers.Locale !== 'en-US' && headers.Locale !== 'en-CA' && headers.Locale !== 'en-CH'
    && headers.Locale !== 'en-GB') {
      headers['Locale'] = 'en-US';
      headers['CultureCode'] = 'en-US';
    }
    else if (headers.Locale && headers.Locale == 'es-WA') {
      headers['Locale'] = 'es-US';
      headers['CultureCode'] = 'es-US';
    }

    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/providers/myria/http-mapper.ts